/*
 * @Author: Wang Bingjing
 * @Date: 2021-02-22 15:27:48
 * @LastEditTime: 2021-07-20 21:03:08
 * @LastEditors: zhengfan
 */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { OverallProvider } from './store/overallStore'

ReactDOM.render(
 /*  <React.StrictMode> */
    <OverallProvider>
      <App />
    </OverallProvider>
  /* </React.StrictMode> */,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
